import React from "react";
import { PropTypes } from "prop-types";

const Button4 = ({
  color,
  onClick,
  formdisable,
  disabled,
  width,
  height,
  children,
  type
}) => {
  return (
    <button
      disabled={disabled || formdisable}
      onClick={onClick}
      style={{ color: `${color}`, height: `${height}`, width: `${width}`, marginBottom: "1rem" }}
      className="button-app-proceed"
      type={type}
    >
     {children}
    </button>
  );
};

Button4.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func,
  formdisable: PropTypes.func,
  disabled: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  children: PropTypes.node, 
  type: PropTypes.string
}

export default Button4;
